import { render, staticRenderFns } from "./RRP.vue?vue&type=template&id=0e13223e&"
import script from "./RRP.vue?vue&type=script&lang=js&"
export * from "./RRP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports